<template>
  <div class="container">
    <Icon type="ios-trash" size="20" @click="modalConfirmation"/>
    <Modal
      v-model="confirmation"
      width=400
      :footer-hide= true
      :closable = false
    >
      <div class="check-foto_container">
        <h1>Delete user Confirmation</h1>
        <p>Are you sure you want to permanently delete user with the email address <strong>{{row.email}}</strong> ? This action cannot be undone in the future.</p>
        <div class="check-foto_container-button">
          <button @click="cancel">Cancel</button>
          <button @click="deleteUser(row.id)">Delete user</button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  export default {
    props: {
      row: {
        type: Object
      }
    },
    data() {
      return {
        confirmation: false
      }
    },
    methods: {
      modalConfirmation() {
        this.confirmation = !this.confirmation
      },
      cancel() {
        this.confirmation = false
      },
      deleteUser(id) {
        this.$store.dispatch('deleteUser', id)
        .then(() => {
          this.confirmation = false
          this.$Message.success({
            content: "User has been deleted!",
            duration: 5
          })
          location.reload()
        })
        .catch(err => {
          this.confirmation = false
          this.$Message.error({
            content: err.response.data.error,
            duration: 5
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.check-foto_container {
  padding: 5px;
  h1 {
    text-align: center;
    margin-bottom: 30px;
  }
  p  {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 40px;
  }
  &-button {
    display: flex;
    justify-content: center;
    button {
      width: 50%;
      
      text-transform: uppercase;
      border: none;
      border-radius: 4px;
      outline: none;
      padding: 16px;
      cursor: pointer;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
    button + button {
      margin-left: 10px;    
      background-color: #FFE709;
    }
  }
}
</style>